export default __webpack_public_path__ + "static/img/minus.13ef3ab.svg";